const { REACT_APP_ENVIRONMENT } = process.env

export enum Env {
  dev = 'dev',
  stg = 'stg',
  prod = 'production',
}

export const environment = REACT_APP_ENVIRONMENT as Env
